<h3 mat-dialog-title>Ajouter une permission</h3>
<mat-dialog-content class="caaks-dialog-text">
  <div>Renseigner les informations suivantes.</div>
  <div>
    <form [formGroup]="permissionForm" novalidate>
      <div>

        <mat-form-field>
          <input matInput formControlName="name" placeholder="nom" required />
          @if (name!.hasError('invalid')) {
            <mat-error>
              Le nom est mal formaté.
            </mat-error>
          }
          @if (name!.hasError('uniqueName')) {
            <mat-error>
              Un compte existe déjà avec cet name.
            </mat-error>
          }
          @if (name!.hasError('required')) {
            <mat-error> Le nom est requis. </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <input matInput formControlName="resource" placeholder="Type de ressource" required />
          @if (resource!.hasError('invalid')) {
            <mat-error>
              La resource est mal formaté.
            </mat-error>
          }
          @if (resource!.hasError('uniqueName')) {
            <mat-error>
              Un compte existe déjà avec cet name.
            </mat-error>
          }
          @if (resource!.hasError('required')) {
            <mat-error> La resource est requis. </mat-error>
          }
        </mat-form-field>


        <mat-form-field>

          <input type="text" placeholder="Tapez le nom de la ressource" aria-label="Number" matInput
            formControlName="resources" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            @for (option of  filteredResourcesByName|async; track option) {
              <mat-option [value]="option.name">
                {{option.name}}
              </mat-option>
            }
          </mat-autocomplete>
          @if (resources!.hasError('uniqueName')) {
            <mat-error>
              Une ressource existe déjà avec ce nom.
            </mat-error>
          }
          @if (resources!.hasError('required')) {
            <mat-error> Le nom est requis. </mat-error>
          }
        </mat-form-field>

        <mat-checkbox formControlName="usePattern">Utiliser un filtre (ex: DEV-*)</mat-checkbox>

        @if (usePattern?.value) {
          <mat-form-field>
            <input matInput formControlName="resources" placeholder="Tapez le filtre" />
            @if (resources!.hasError('uniqueName')) {
              <mat-error>
                Une ressource existe déjà avec ce nom.
              </mat-error>
            }
            @if (resources!.hasError('required')) {
              <mat-error> Le nom est requis. </mat-error>
            }
          </mat-form-field>
        }

        <mat-form-field>

          <input type="text" placeholder="Autorisation" aria-label="Number" matInput formControlName="policies"
            [matAutocomplete]="autoP">
          <mat-autocomplete #autoP="matAutocomplete">
            @for (option of  filteredPoliciesByName|async; track option) {
              <mat-option [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-autocomplete>
          @if (policies!.hasError('uniqueName')) {
            <mat-error>
              Une ressource existe déjà avec ce nom.
            </mat-error>
          }
          @if (policies!.hasError('required')) {
            <mat-error> Le nom est requis. </mat-error>
          }
        </mat-form-field>

      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container>
    <button mat-button type="submit" color="primary" [disabled]="isCreateDisabled()" (click)="add()">Créer</button>
    <button mat-button (click)="cancel()">Annuler</button>
  </ng-container>
</mat-dialog-actions>